<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ $t('companies.link_company') }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="empresaSelected">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $tc('companies.entity_name', 1) }}</label>
              <el-form-item prop="empresaSelected">
                <base-el-select ref="statusesSelect" class="w-full" :options="empresas" v-model="form.empresaSelected" multiple filterable :disabled="isLoadingSelect" @visible-change="onExpand" @change="onChangeInput" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button mode="secondary-phantom-blue"
        class="w-full"
        v-if="!isAllSelected" 
        :disabled="!isLoadedData || isLoadingSelect || isEmptyList" 
        :text="$t('app.select_all')" 
        @click="$refs.statusesSelect.selectAll()" 
        :loading="isLoadingSelect"
        />
      <base-button v-else :text="$t('app.unselect_all')" mode="secondary-phantom-blue"
        class="w-full"
        @click="$refs.statusesSelect.unselectAll()"
        :loading="isLoadingSelect"
        :disabled="isLoadingSelect || isEmptyList"
        />
        <div class="w-48 "></div>
      <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
        class="w-full"
        :loading="isLoadingSelect"
        :disabled="isLoadingSelect"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="apply('ruleForm')" 
        :loading="isLoadingSelect"
        :disabled="isLoadingSelect"/>
    </template>
  </base-dialog-button>
</template>

<script>

import BaseDialogButton from './base/BaseDialogButton.vue'
import { i18n } from '@/i18n'
import { getAllCompanies } from '@/services/companies/getAllCompanies'
import { companies } from '@/services/app/getCompanies'


export default
{
  name: 'link-company-sociedad-dialog',
  components: {
    BaseDialogButton
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    idCliente: {
      type: Number,
      default: null
    },
    linkedCompanies: {
      type: [Promise],
      default: null
    },
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        empresaSelected: []
      },
      empresas: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false,
      rules: {
        empresaSelected: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
      }
    }
  },
  mounted: async function () {
    this.isLoadedData = false

    const linkedCompaniesRes = await this.getLinkedCompanies()
    const linkedCompaniesIds = linkedCompaniesRes.respuesta.map(x => x.IdCIFEmpresa)

    const allCompaniesData = await this.getCompanies()

    const availableCompanies = allCompaniesData.CIFSEmpresa.filter(
      company => !linkedCompaniesIds.includes(company.IdCIFEmpresa)
    )

    this.empresas = availableCompanies.map(x => ({ 
      label: x.RazonSocial, 
      value: x.IdCIFEmpresa 
    }))

    this.isLoadedData = true
  },

  computed: {
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isEmptyList: function () {
      return this.empresas === undefined || this.empresas === null || this.empresas.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.empresas.length === this.form.empresaSelected.length) return true
      else return false
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
  },
  methods: {
    getLinkedCompanies: async function () {
      const objOrder = await this.linkedCompanies
      const payload = { idSociedad: parseInt(this.$route.params.id) }
      const res = await companies(objOrder, payload)
      if (res.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', res))
      } else {
        return res
      }
    },
    getCompanies: async function () {
      if (!this.idCliente) {
        this.doFeedback(i18n.t('feedback.error.idCliente_error'))
        return { CIFSEmpresa: [] }
      }
      const params = {
        idCliente: this.idCliente
      }
      const data = await getAllCompanies(params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
        return { CIFSEmpresa: [] }
      } else {
        return data
      }
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs?.selectRef?.clientHeight || 64
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.empresaSelected = []
    },
    apply: function (ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          this.$emit('applyDialog', this.form.empresaSelected)
          // this.isOpen = !this.isOpen
          // this.form.empresaSelected = []
          // this.toggleDialog()
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped></style>
